<template>
  <div class="flex flex-col justify-between h-full">
    <slot></slot>
    <XSiderMenu class="flex-1" />
    <XSiderUserInfo v-if="isHome && userInfo?.user_id" class="user-wrapper" />
  </div>
</template>
<script lang="ts" setup>
import { useDetector } from '~/hooks/useDetector';

const { isHome } = useDetector();

const userInfo = useUserInfo();
</script>

<style lang="scss"></style>
